import { render, staticRenderFns } from "./GalleryFrame.vue?vue&type=template&id=7a1f135e&scoped=true&"
import script from "./GalleryFrame.vue?vue&type=script&lang=js&"
export * from "./GalleryFrame.vue?vue&type=script&lang=js&"
import style0 from "./GalleryFrame.vue?vue&type=style&index=0&id=7a1f135e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1f135e",
  null
  
)

export default component.exports